export default "__VITE_ASSET__19e4f6c6__"